export default __webpack_public_path__ + "static/media/ba2.a5d2217e.jpg";